module.exports = __webpack_public_path__ + "media/images/area/feature/banner/en/pc/en_hokkaido-07c4a1344c16154fdf5f7f4eca4c3091.png";